import { WorkBook } from 'xlsx-js-style';
import { ExcelTemplate } from '../../interfaces';
import * as XLSX from 'xlsx-js-style';
import { withHeaderStyling } from '../../utils';
import { fitToColumn } from '../financial-statement/utils';
import { getPreparedData } from './mapping';
import { FinDataPeriods }
  from 'src/app/domain/portfolio-comparison/component/fin-data-period-comparison/fin-data-period-comparison.component';
import { MainDataPeriodComparison } from 'src/app/domain/portfolio-comparison/dto/CompanyFinDataAndCalculations';

export class ComparisonByValueTemplate implements ExcelTemplate {
  export(data: ComparisonByValueWrapper): WorkBook {
    const book = XLSX.utils.book_new();
    const sheet = this.getSheet(data);
    XLSX.utils.book_append_sheet(book, sheet);
    return book;
  }

  getSheet(data: ComparisonByValueWrapper) {
    const preparedData = getPreparedData(data);
    const sheet = {
      ...XLSX.utils.aoa_to_sheet(preparedData),
      '!cols': fitToColumn(preparedData),
    };
    return withHeaderStyling(sheet);
  }

  getHeaders(data: ComparisonByValueWrapper) {
    return data.periods.filteredPeriods;
  }
}

export interface ComparisonByValueWrapper {
  periods: FinDataPeriods;
  data: MainDataPeriodComparison[];
  selectedTab: string;
}
